const gpToCostReportFilters = {
  year: new Date().getFullYear(),
  userId: null
}

export default () => Object.assign({}, gpToCostReportFilters)
